import { ErpDataTableV2 } from '@/components/custom/erp/data-table-v2';
import type { AritoTablesProps } from './types';

export default function AritoDataTables({
  tables,
  pageSize = 10,
  pageSizeOptions = [10, 20, 50, 100],
  onRowClick,
  onRowDoubleClick,
  onTabChange,
  selectedRowId,
  defaultTabIndex = 0,
  getRowId,
  totalItems = 0,
  currentPage = 0,
  onPageChange,
  onPageSizeChange,
  serverSidePagination = false,
  onSearchChange,
  loading = false
}: AritoTablesProps) {
  const isServerSidePagination = serverSidePagination || Boolean(onPageChange);

  return (
    <ErpDataTableV2
      tables={tables as any}
      pageSize={pageSize}
      pageSizeOptions={pageSizeOptions}
      onRowClick={onRowClick as any}
      onRowDoubleClick={onRowDoubleClick as any}
      onTabChange={onTabChange}
      selectedRowId={selectedRowId}
      defaultTabIndex={defaultTabIndex}
      getRowId={getRowId}
      totalItems={totalItems}
      currentPage={currentPage}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      serverSidePagination={isServerSidePagination}
      onSearchChange={onSearchChange as any}
      loading={loading}
      showIndexColumn
      widthMode='content'
    />
  );
}
